import { render, staticRenderFns } from "./ForgotPasswordCard.vue?vue&type=template&id=3a209772&scoped=true&"
import script from "./ForgotPasswordCard.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordCard.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordCard.vue?vue&type=style&index=0&id=3a209772&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a209772",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VCard,VCol,VDivider,VForm,VImg,VRow,VTextField})
